import React from 'react';
import Header from './ui/Header';
import { useAuth } from '../contexts/AuthContext';

const Layout = ({ children, showHeader = true }) => {
  const { loading } = useAuth();

  // Loading state
  if (loading) {
    return (
      <div className="min-h-screen bg-background">
        <div className="flex items-center justify-center h-64">
          <div className="animate-spin rounded-full h-8 w-8 border-b-2 border-primary"></div>
        </div>
      </div>
    );
  }

  return (
    <div className="min-h-screen bg-background">
      {showHeader && <Header />}
      <main className={showHeader ? "pt-16" : ""}>
        {children}
      </main>
    </div>
  );
};

export default Layout;